const template = `
<div class="vue_main-filters">
  <div class="vue_filter-block">
    <label for="findword" :class="[isoneLabel ? labelclasstrue : labelclassfalse]">{{ jsonval.keyphrase }}</label>
    <input class="form-control" type="text" :placeholder="jsonval.keyphrase" name="findtext" id="findword" v-model="one">
  </div>
  <div class="vue_filter-block">
    <label :class="[istwoLabel ? labelclasstrue : labelclassfalse]">{{ jsonval.price }}</label>
    <div class="vue_double-input">
        <input type="number" step="any" class="form-control" :placeholder="jsonval.from" name="price_before_new" v-model="mintwo">
        <input type="number" step="any" class="form-control" :placeholder="jsonval.to" name="price_after_new" v-model="maxtwo">
    </div>
    <input type="hidden" name="price_before" v-model="mintwo">
    <input type="hidden" name="price_after" v-model="maxtwo">
  </div>
  <div class="vue_filter-block">
    <label :class="[isthreeLabel ? labelclasstrue : labelclassfalse]">{{ jsonval.product }}</label>
    <div>
      <input class="ok-input-checkbox" type="checkbox" name="item_status" id="checkbox-group" value="1" v-model="three">
      <label for="checkbox-group"><i class="fa"></i>{{ jsonval.isproductexist }}</label>
    </div>
    <div>
      <input class="ok-input-checkbox" type="checkbox" name="discount" id="checkbox-group1" value="1" v-model="isSale">
      <label for="checkbox-group1"><i class="fa"></i>{{ jsonval.isSale }}</label>
    </div>
  </div>
</div>`


export default template



// WEBPACK FOOTER //
// ./src/components/templates/45/firstfindblock.js